jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {});

  // BentoSMB
  function removeBundleFromCart() {
    const ids = $(this).data("ids").split(",");

    const updates = {};
    for (const id of ids) {
      updates[id] = 0;
    }

    console.log(updates);

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: {
        updates,
      },
      dataType: "json",
      async: false,
    });
  }

  $("[data-cart-remove-bundle]").click(removeBundleFromCart);
});
